import React from 'react';

export function HistoryTab({ newsletterHistory }) {
  if (newsletterHistory.length === 0) {
    return (
      <div className="bg-gray-800/50 rounded-xl border border-gray-700 p-8 text-center text-gray-500">
        No newsletters sent yet
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {newsletterHistory.map((item) => (
        <div key={item.id} className="bg-gray-800/50 rounded-xl border border-gray-700 p-6">
          <div className="flex flex-wrap items-start justify-between gap-4 mb-3">
            <h3 className="text-lg font-semibold text-gold-400">{item.subject}</h3>
            <div className="flex items-center gap-3 text-sm">
              <span className="text-green-400">{item.successful} sent</span>
              {item.failed > 0 && (
                <span className="text-red-400">{item.failed} failed</span>
              )}
            </div>
          </div>
          <p className="text-gray-400 text-sm line-clamp-2 mb-3">{item.content}</p>
          <p className="text-gray-500 text-xs">
            Sent: {new Date(item.sent_at).toLocaleString()} • {item.total_recipients} recipients
          </p>
        </div>
      ))}
    </div>
  );
}
